<script>
import Validation from '@/plugins/validation'
import { InputWithObj, Select } from '@/components/formelements'
import DataTable from '@/components/DataTable'
import { mapState } from 'vuex'

export default {
  name: 'Merchant',
  props: ['id'],
  async mounted() {
    this.$store.dispatch('merchant/RESET')
    await this.$store.dispatch('merchant/SET_MERCHANT', this.id)
  },
  data() {
    return {
      ...Validation,
    }
  },
  components: {
    InputWithObj,
    Select,
    DataTable
  },
  computed: {
    ...mapState({
      merchantInfo: state => state.merchant.merchantInfo,
      orgMerchantInfo: state => state.merchant.orgMerchantInfo,
      retailData: state => state.merchant.retailData,
      headers: state => state.merchant.headers,
      statesAPI: state => state.merchant.states,
      countries: state => state.merchant.countries,
      statusTypes: state => state.search.statusTypes
    }),
    statesItems(){
      return this.statesAPI.map( state => {
        return { text: state.Name, value: state.Code }
      })
    },
    countriesItems() {
      return this.countries.map( country => {
        return { text: country.Abbreviation, value: country.ID }
      })
    },
    getRowStatus: function() {
      if (this.merchantInfo.RowStatus == undefined ) return 'Active'
      const status = this.statusTypes.filter( type => type.ID == this.merchantInfo.RowStatus )
      return status[0].Name
    }
  },
  methods: {
    async saveUpdates(){
      if(this.$refs.updateForm.validate()) {
        if (this.id == 0){
          await this.$store.dispatch('merchant/INSERT_MERCHANT')
          this.$router.push({name: 'Merchant', params: { id: this.merchantInfo.ID }})
        } else {
          await this.$store.dispatch('merchant/UPDATE_MERCHANT')
        }
      }
    },
    async newMerchant(){
      await this.$store.dispatch('merchant/RESET')
      await this.$store.dispatch('merchant/SET_MERCHANT', '0')
    },
    async newRetailer(){
      await this.$store.dispatch('retailer/RESET')
      await this.$store.dispatch('retailer/SET_RETAILER')
    },
    async countryUpdate(e){
      await this.$store.dispatch('merchant/GET_STATES', e)
    }
  }
}
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col class="pl-6" cols="12" sm="6">
        <v-form ref="updateForm">
          <v-row>
            <v-col cols="6">
              Merchant ID: {{ merchantInfo.ID }}
            </v-col>
            <v-col cols="6">
              Row Status: <span :class="{ 'green--text font-weight-black': merchantInfo.RowStatus == 1 || merchantInfo.RowStatus == undefined}">{{ getRowStatus }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <InputWithObj :rules="[...required]" form="merchant" field="merchantInfo" objkey="Name" label="Merchant Name" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <InputWithObj :rules="[...required]" form="merchant" field="merchantInfo" objkey="Address1" label="Address 1" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <InputWithObj form="merchant" field="merchantInfo" objkey="Address2" label="Address 2" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <InputWithObj form="merchant" field="merchantInfo" objkey="Address3" label="Address 3" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <InputWithObj :rules="[...required]" form="merchant" field="merchantInfo" objkey="City" label="City" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <Select :rules="[...required]" form="merchant" field="merchantInfo" objkey="CountryCode" :items="countriesItems" label="Country" @change="countryUpdate" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" >
              <Select :rules="[...required]" form="merchant" field="merchantInfo" objkey="State" :items="statesItems" label="State/Province" />
            </v-col>
            <v-col cols="12" sm="6" >
              <InputWithObj :rules="[...required]" form="merchant" field="merchantInfo" objkey="PostalCode" label="Zip/Postal Code" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              Last updated By <br/> {{ merchantInfo.LastUpdatedBy }}
            </v-col>
            <v-col cols="6">
              Last Updated Date <br/> {{ merchantInfo.LastUpdateDate }}
            </v-col>
          </v-row>  
          <v-row>
            <v-col cols="12" sm="6">
              <router-link to='/merchant/0' >
                <v-btn @click="newMerchant" depressed color="accent">
                  <v-icon left>mdi-plus-box</v-icon>Create New Merchant
                </v-btn>
              </router-link>
            </v-col>
            <v-col class="d-flex justify-end" cols="12" sm="6">
              <v-btn :disabled="!$store.getters['merchant/merchantChanged']" @click="saveUpdates" width="125px" depressed color="accent">
                <v-icon left>mdi-content-save</v-icon> Save
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card >
          <v-card-title>
            {{ orgMerchantInfo.Name }} Retailers
          </v-card-title>
        <DataTable :headers="headers" :items="retailData" />
        <v-card-actions>
            <v-btn :disabled="id == 0" to="/retailer/0"  @click="newRetailer" depressed color="accent">
              <v-icon left>mdi-plus-box</v-icon>Create New Retailer
            </v-btn>
        </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
